module.exports = __webpack_public_path__ + "static/media/wifi.a7396c33.svg";